<ng-container *ngIf="!config.esModalProceso">
  <div>
    <em
      class="material-icons color-blue-dark icon-calcel cursor"
      (click)="cerrarDialogo()">
      cancel
    </em>
  </div>
</ng-container>

<div class="cuadro-modal">
  <ng-container *ngIf="config.esModalProceso">
    <div class="spinner">
    </div>
  </ng-container>
  <div class="justify-content-center" >
    <div >
      <img  src="{{config.icono}}">
    </div>
    <div>
      <p>{{config.titulo}}</p>
      <br>
    </div>
    <div>
      <p>{{config.textoDescriptivo}}</p>
    </div>

  <ng-container *ngIf="!config.esModalProceso">
    <br>
    <div>
      <a 
      role="button"
      href="javascript:"
      (click)="cerrarDialogo()"
      class="u-btn u-btn--icon u-btn--yellow font-16">
       Aceptar
      </a>
    </div>
  </ng-container>

    <!-- <p [innerHTML]="config.titulo"></p> -->
  </div>
  <!-- <div class="steps-cont_actions d-flex justify-content-center pt-10"></div> -->
</div>
